import type { WorkflowApi } from '../api/WorkflowApi'
import type { WorkflowSchedule, WorkflowScope } from '../models/workflow.types'

export interface ScheduleActionOptions {
  api: Pick<WorkflowApi, 'pauseSchedule' | 'resumeSchedule' | 'deleteSchedule'>
  notify: (action: 'paused' | 'resumed' | 'deleted') => void
  reload: () => Promise<void>
}

export class WorkflowScheduleActions {
  constructor(private readonly options: ScheduleActionOptions) {}

  async setActive(scope: WorkflowScope, schedule: WorkflowSchedule): Promise<void> {
    if (schedule.is_active) await this.options.api.pauseSchedule(scope, schedule.id)
    else await this.options.api.resumeSchedule(scope, schedule.id)
    this.options.notify(schedule.is_active ? 'paused' : 'resumed')
    await this.options.reload()
  }

  async remove(scope: WorkflowScope, schedule: WorkflowSchedule): Promise<void> {
    await this.options.api.deleteSchedule(scope, schedule.id)
    this.options.notify('deleted')
    await this.options.reload()
  }
}
